import { TermsContainer } from '@components/Container';
import Content from '@components/Content';
import { H1 } from '@components/Heading';
import { RouterLink } from '@components/Link';
import useImpersonate from '@State/Impersonate/useImpersonate';
import React, { useEffect } from 'react';

const TermsOfUse = () => {
  const { impersonate } = useImpersonate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <TermsContainer $impersonate={!!impersonate}>
      <Content>
        <H1 style={{ marginTop: 0 }}>
          Användarvillkor för REMONDIS <br /> Kundportal och App
        </H1>
        <p>
          REMONDIS Sweden AB nedan REMONDIS, tillhandahåller Kundportal och App i syfte att
          underlätta för dig som Kund till REMONDIS. Dessa villkor utgör avtal för användandet av
          Kundportal och App som uppkopplad tjänster. Kunden förbinder sig att följa dessa
          avtalsvillkor när Kunden loggar in i Kundportal eller App med sina inloggningsuppgifter.
        </p>
        <p>
          Informationen i Kundportal och App är baserad på de uppgifter som REMONDIS har erhållit
          avseende Kunden och Kundens avtal med REMONDIS.
        </p>
        <h2>Syfte med Kundportalen</h2>
        <p>
          Syftet med Kundportalen är att underlätta för dig som Kund till REMONDIS och /eller dess
          dotterbolag genom att tillhandahålla information om gällande avtal med dig med tillhörande
          tjänster. Du som Kund är medveten om att dokumentation och information om dig kommer att
          användas för detta ändamål i Kundportalen. Tillgång till Kundportalen gäller endast för
          dig som har ett avtal med REMONDIS. Har du inte inget avtal med REMONDIS är du inte
          behörig att använda Kundportalen och ska omedelbart upphöra med att använda Kundportalen.
        </p>
        <h2>Åtkomst till Kundportalen</h2>
        <p>
          Kunden erhåller inloggningsuppgifter från REMONDIS att få åtkomst till Kundportal och App.
          Som Kund ansvarar du för att användare av Kundportal och/eller App inom sin organisation
          använder sina individuella inloggningsuppgifter och att samtliga användare hos Kunden har
          fått rätt utbildning internt för att använda utrustning och/eller programvara för att få
          tillgång till Kundportal och App.
        </p>
        <p>
          Kunden ansvarar för att säkerställa att endast behöriga personer får tillgång till
          inloggningsuppgifter till Kundportal och App och att lämpliga säkerhetsåtgärder vidtas för
          skydd från obehörigt intrång och otillåtna beteenden. Kunden ansvarar för alla aktiviteter
          i Kundportal och App som sker via sin inloggning. Om Kunden misstänker att någon obehörig
          har fått tillgång till inloggningsuppgifter till Kundportal eller App ska lösenord
          omedelbart ändras. Om lösenordet inte kan ändras ska Kunden kontakta REMONDIS. REMONDIS
          ska också kontaktas omedelbart om inloggningsuppgifter blir kända eller tillgängliga för
          en obehörig person eller en person som inte längre ska använda Kundportal eller App.
        </p>
        <p>
          Om du som Kund får kännedom om obehörig användning av eller åtkomst till Kundportal eller
          App eller andra överträdelser kopplade till användningen av Kundportal och App ska du
          vidta övriga rimliga åtgärder för att säkerställa att sådan användning eller aktivitet
          upphör och förhindra att det upprepas samt informera REMONDIS.
        </p>
        <p>
          REMONDIS förbehåller sig rätten att ändra, tillfälligt stänga av och avsluta hela eller
          delar av Kundportal och App och innehållet på dessa, utan att meddela Kunden detta. Om ett
          användarkonto inte har använts för att få åtkomst till Kundportal och App under en period
          av ett år har REMONDIS rätt att avbryta detta användarkonto utan att meddela Kunden i
          förväg.
        </p>
        <h2>Användningen av Kundportal och App</h2>
        <p>
          <strong>För att använda Kundportal och App ansvarar du som kund för att:</strong>
        </p>
        <ul>
          <li>
            Utrustning och programvara som används för åtkomst till Kundportal och App används på
            ett sådant sätt att det inte påverkar webbplatsen i Kundportal eller innehållet i
            Kundportal eller App negativt samt att dess säkerhet, funktionalitet är kompatibla med
            Kundportal och App och dess tjänster. REMONDIS har inget ansvar för att Kundportal och
            App inte kan användas på Kundens anordningar eller eventuella defekter eller fel på
            sådan utrustning och/eller programvara eller för bristande åtkomst till Kundportal eller
            App.
          </li>
          <li>
            Utrustning och programvara inte används för att komma åt eller hämta data som du som
            Kund inte har åtkomst eller behörighet till.
          </li>
        </ul>
        <p>
          <strong>REMONDIS har rätt att när som helst:</strong>
        </p>
        <ul>
          <li>
            Ändra användarvillkoren för Kundportal och App i syfte att uppdatera och utveckla
            funktioner i Kundportal och App för att förbättra tjänsten för dig som Kund, dvs. göra
            ändringar i utbud, omfattning och innehåll i Kundportal och App.
          </li>
          <li>
            Frånta Kunden användarrättigheter till Kundportal och App eller kräva att du som Kund
            kopplar bort utrustning och programvara om utrustningen och programvaran är eller har
            varit orsaken eller varit den bidragande orsaken till eller sannolikt kommer att vara
            orsak till fel, avbrott, fel eller defekter i Kundportal eller App eller om Kundens
            anordningar, program eller förbindelser utgör risk för Kundportalens eller Appens
            säkerhet eller om säkerställandet av datasäkerheten i övrigt kräver det.
          </li>
          <li>
            Stänga av åtkomst till Kundportal och App för ändring, reparation, underhåll eller
            support, eller om det finns eller antas finnas eventuella fel i Kundportal och eller App
            eller om det finns anledning att tro att Kundportal eller App används på ett sätt som
            kan förorsaka skada för parterna eller utomstående.
          </li>
          <li>
            Ändra specifikationer och krav på anordningar, utrustning och program som behövs för
            åtkomst till Kundportal och App.
          </li>
          <li>
            Stänga av åtkomst till Kundportal och App om det i övrigt anses nödvändigt av
            kommersiella skäl, på grund av force majeure.
          </li>
          <li>
            Använda eller tillåta användning av automatiserade programvaruagenter (inklusive utan
            begränsning, eventuell skärmskrapa, spindel eller annan så kallad webcrawler) för att
            komma åt kundportal eller för att söka, kopiera, övervaka, visa eller få länkar till
            någon del av kundportal.
          </li>
          <li>Publicera erbjudanden och information om REMONDIS tjänster och produkter.</li>
        </ul>
        <p>Som Kund har du ett ansvar att inte:</p>
        <ul>
          <li>
            Vidta åtgärder i data, system eller er databas som ingår i Kundportal och App för att
            exempelvis rätta eventuella felaktigheter, inklusive anlitande av tredje part för att
            vidta sådana åtgärder.
          </li>
          <li>
            På annat sätt manipulera, radera, införa tillägg, justeringar eller vidta ändringar av
            Kundportal eller App.
          </li>
          <li>
            Använda Kundportal eller App eller låta den användas för bedrägliga eller andra olagliga
            och oegentliga syften eller aktiviteter, eller för att kränka REMONDIS upphovsrätt eller
            annan immateriell äganderätt eller någon annan persons rättigheter. REMONDIS har
            upphovs- och äganderätt till alla tjänster, varumärken, logotyp och andra immateriella
            rättigheter som visas på Kundportal och App.
          </li>
          <li>
            Kopiera, sprida, använda, överföra, länka till webbsidor, affärsmässigt nyttja,
            publicera eller sälja data från Kundportal eller App utan samtycke från REMONDIS.
          </li>
        </ul>
        <p>
          Kunden åtar sig att uppfylla alla skyldigheter enligt tillämplig dataskyddslagstiftning.
        </p>
        <h2>Konsekvenser</h2>
        <p>
          Om du som Kund inte följer dessa användarvillkor eller om misstanke finns om att
          Kundportal eller App används i strid med lag eller i strid mot dessa villkor har REMONDIS
          rätt att vidta nödvändiga åtgärder inklusive att avsluta Kundens samtliga
          inloggningsuppgifter till Kundportal och App. REMONDIS förbehåller sig också rätten att
          avbryta Kundens inloggningsmöjlighet och användarkonto när som helst om det finns
          anledning att misstänka användning av kundportal eller App för bedrägligt eller annat
          olagligt syfte eller aktivitet samt att inaktivera eller ta bort ett konto om det krävs
          för att efterleva juridiskt krav eller domstolsbeslut.
        </p>
        <p>
          REMONDIS kan, om misstanke om Kundportal eller App används i strid med lag eller dessa
          allmänna villkor, följa upp Kundens användning av Kundportal eller App för att verifiera
          att kraven i dessa användarvillkor följs och för att kontrollera åtkomst till och
          användning av information. Kunden ansvarar vidare för att ersätta REMONDIS för de skador
          som REMONDIS åsamkas för en felaktig användning av Kundportal eller App.
        </p>
        <h2>Ansvarsbegränsning</h2>
        <p>
          REMONDIS garanterar inte att Kundportal och App är tillgänglig utan avbrott och utfäster
          ingen garanti om tillgänglighet till Kundportal och App.
        </p>
        <p>
          Så långt det är tillåtet enligt lag är varken REMONDIS eller någon tredje part som
          REMONDIS anlitat ansvarig för skada, varken direkt eller indirekt, oavsett orsak, såsom
          exempelvis för skada som uppstår vid avstängning av Kundportal eller App eller annars från
          tillgängligheten till Kundportal eller App, tillgängligheten till tjänsterna eller data,
          förlust eller skada på utrustning och programvara eller icke-konfiguration av data eller
          annars som kan uppkomma genom användning av eller hinder från att använda Kundportal eller
          App. REMONDIS ansvarar inte heller för skador som förorsakas av force majeure eller av
          motsvarande orsaker, såsom exempelvis myndighetsåtgärd, störning i datakommunikation,
          tillgång till el, arbetsrelaterade konflikter etc.
        </p>
        <p>
          Data i kundportal och App bygger på information i verksamhetssystem. REMONDIS eftersträvar
          att informationen ska återges på korrekt sätt, men är inte ansvariga för eventuella
          felaktigheter. REMONDIS kommer dock att verka för att eventuella felaktigheter som
          upptäcks åtgärdas så långt det är möjligt. REMONDIS har inget ansvar för förlust som
          uppstår till följd av att du som Kund litar på riktigheten av informationen i Kundportal
          eller App.
        </p>
        <p>
          REMONDIS ansvarar inte för skada som förorsakas Kunden på grund av förlorad eller ändrad
          information i det allmänna kommunikationsnätet eller i ett informationsnät som ägs,
          administrerar eller via avtal används av Kunden. REMONDIS ansvarar inte heller för skador
          som förorsakas Kunden på grund av en uppkommen informationssäkerhetsrisk.
        </p>
        <p>Kunden har inte rätt till ersättning på grund av att detta avtal avslutas.</p>
        <h2>Användning av information</h2>
        <p>
          REMONDIS har rätt att elektroniskt samla in, spara och arkivera information om avtal med
          Kunden och uppdrag som gjorts genom Kundportal och App, meddelande som skickats av Kunden
          samt Kundens övriga ärenden. Den information som används för kundrelationen kan användas i
          utveckling av uppkopplade tjänster.
        </p>
        <p>
          Du som Kund ger REMONDIS tillstånd att lagra och behandla personuppgifter för att uppfylla
          tillhandahållandet av Kundportal och App.
        </p>
        <p>
          Se vidare{' '}
          <RouterLink to="/privacy-policy">
            REMONDIS ANVÄNDARVILLKOR, BEHANDLING AV PERSONUPPGIFTER OCH COOKIES
          </RouterLink>
        </p>
        <h2>Ändring av användarvillkoren</h2>
        <p>
          REMONDIS förbehåller sig rätten att ändra alla eller delar av dessa användarvillkor. Sådan
          ändring meddelas i Kundportal och App och godkänns av Kunden i samband med ny inloggning.
          Om Kunden inte godkänner de ändrade villkoren ska Kunden säga upp detta avtal skriftligen
          innan ändringen träder ikraft. Användningen av Kundportal och App efter att en sådan
          ändring har publicerats på Kundportal och App kommer att anses godkänd av dig som Kund för
          de nya modifierade användarvillkoren.
        </p>
        <h2>Avtalets giltighet</h2>
        <p>
          Detta avtal träder i kraft när Kundens loggar in i Kundportal eller App och godkänner
          detta avtal. <br /> Detta avtal gäller tillsvidare.
        </p>
        <p>
          REMONDIS kan säga upp detta avtal som avslutas en månad efter uppsägningen. REMONDIS har
          även rätt att häva detta avtal om Kundportal eller App har avbrutits av någon anledning
          som beror på Kundens agerande, så som missbruk av den uppkopplade tjänsten eller om Kunden
          på annat sätt väsentligt bryter mot villkoren i detta avtal. Som följd av hävningen upphör
          detta avtal omedelbart.
        </p>
        <p>
          Kunden kan säga upp detta avtal till omedelbart upphörande men med rimlig tid för REMONDIS
          att avsluta användarrättigheterna.
        </p>
        <p>
          Kunden har inte rätt att överföra detta avtal till tredje part. REMONDIS har rätt att
          överföra detta avtal till ett företag eller en organisation som ingår i
          REMONDIS-koncernen.
        </p>
        <h2>Tvist</h2>
        <p>
          Svensk rätt ska tillämpas på detta avtal och tvist i anledning av detta avtal ska prövas
          av svensk allmän domstol.
        </p>
      </Content>
    </TermsContainer>
  );
};

export default TermsOfUse;
